import { render, staticRenderFns } from "./Logbook.vue?vue&type=template&id=c8b53cd2&scoped=true"
import script from "./Logbook.vue?vue&type=script&lang=js"
export * from "./Logbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b53cd2",
  null
  
)

export default component.exports